import { render, staticRenderFns } from "./l30index.vue?vue&type=template&id=27d622a2&scoped=true&"
import script from "./l30index.vue?vue&type=script&lang=js&"
export * from "./l30index.vue?vue&type=script&lang=js&"
import style0 from "./l30index.vue?vue&type=style&index=0&lang=less&"
import style1 from "./l30index.vue?vue&type=style&index=1&id=27d622a2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d622a2",
  null
  
)

export default component.exports